import { getI18nInstance } from '@/i18n';
import { ROLES } from '@/models/User';

import UserIndex from /* webpackChunkName: "admin" */ '@/views/auth/user/index.vue';
import UserEdit from /* webpackChunkName: "admin" */ '@/views/auth/user/_id.vue';
import UserBasisdaten from '@/views/auth/user/_id/Basisdaten.vue';
import UserMetadata from '@/views/auth/user/_id/Metadata.vue';
import UserRelations from '@/views/auth/user/_id/Relations.vue';
import UserChangelog from '@/views/auth/user/_id/Changelog.vue';
import UserProfileForm from /* webpackChunkName: "admin" */ '@/views/auth/user/ProfileView.vue';

export default [
    {
        path: '/user/profile',
        name: 'user-profile',
        component: UserProfileForm,
        meta: {
            requiresAuth: true,
            title: () => getI18nInstance().t('user_profile'),
        },
    },
    {
        path: '/user',
        name: 'user',
        component: UserIndex,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('benutzer'),
        },
    },
    {
        path: '/user/:id',
        component: UserEdit,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('benutzer'),
        },
        children: [
            {
                path: '/',
                name: 'user-edit',
                component: UserBasisdaten,
            },
            {
                path: 'metadata',
                name: 'user-edit-metadata',
                component: UserMetadata,
            },
            {
                path: 'relations',
                name: 'user-edit-relations',
                component: UserRelations,
            },
            {
                path: 'changelog',
                name: 'user-edit-changelog',
                component: UserChangelog,
            },
        ],
    },
];
